export function LogoNoText(props: { class?: string; size?: number }) {
  const height = props.size;
  const width = height ? (height * 148) / 88 : undefined;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 148 88"
      fill="currentColor"
      width={width}
      height={height}
      class={props.class}
    >
      <title>Chief logo</title>
      <path d="M43.833 37.464 18.518 87.067 0 87.078V0zm59.837 0 25.315 49.603 18.518.011V0zm14.89 49.556L74.06 0 29.62 87.079z" />
    </svg>
  );
}
